[
  {
    "code": "VU-MAP",
    "name": "Malampa"
  },
  {
    "code": "VU-PAM",
    "name": "Pénama"
  },
  {
    "code": "VU-SAM",
    "name": "Sanma"
  },
  {
    "code": "VU-SEE",
    "name": "Shéfa"
  },
  {
    "code": "VU-TAE",
    "name": "Taféa"
  },
  {
    "code": "VU-TOB",
    "name": "Torba"
  }
]